import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import LogRocket from 'logrocket';
import createSagaMiddleware from 'redux-saga';
import { createRootReducer } from './root-reducer';
import { rootSaga } from './root-saga';

export const history = createBrowserHistory();

const reducer = createRootReducer();

// const routerMiddleWare = routerMiddleware(history);
const sagaMiddleWare = createSagaMiddleware();
const logRocketMiddleWare = LogRocket.reduxMiddleware({
  stateSanitizer() {
    return {
      // ...state,
      // removeThisKey: undefined,
    };
  },
  actionSanitizer() {
    return {
      // ...action,
      // removeThisKey: undefined,
    };
  },
});

export const store = configureStore({
  reducer,
  middleware: [
    sagaMiddleWare,
    // routerMiddleWare,
    logRocketMiddleWare /* always keep logRocketMiddleWare at the last */,
  ],
});

declare global {
  interface Window {
    Cypress?: unknown;
    store: typeof store;
    Beamer?: any;
  }
}

if (window.Cypress) {
  window.store = store;
}

export type RootState = ReturnType<typeof reducer>;

export const sagaTaskDescriptor = sagaMiddleWare.run(rootSaga);
